class EventModel {
  constructor(
    eventName,
    eventType,
    eventAction,
    eventEffect,
    eventPosition = 1
  ) {
    this.eventName = eventName;
    this.eventType = eventType;
    this.eventAction = eventAction;
    this.eventEffect = eventEffect;
    this.eventPosition = eventPosition;
  }

  // TODO: Implement any neccesary setters and getters!

  getTrackingObject() {
    return {
      name: this.eventName,
      type: this.eventType,
      action: this.eventAction,
      effect: this.eventEffect,
      position: this.eventPosition,
      timestamp: new Date()
    };
  }
}

export default EventModel;
